module.exports = __webpack_public_path__ + "static/img/伙伴客户-高德红外.7d04396b.png";